import { faCheck, faTimes, faExclamationCircle, faTriangleExclamation} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t } from "i18next";
import { useMemo, useRef, useEffect, useState } from "react";
import { maskPhoneInput } from "../../../utils/phone-utils";
import Dropdown from "../../components/Dropdown/Dropdown";
import TextInput from "../../components/TextInput/TextInput";
import phoneCarriers from "../phoneCarriers.json";
import TagManager from "react-gtm-module";
import { US_PHONE_LEN } from "../../../utils/phone-utils";
import { ReactComponent as InfoLogo } from "../../../assets/icons/svg/info-icon.svg";
import { Popper } from "@mui/material";
import { useAppSelector, useAppDispatch } from "../../../hooks/redux-hooks/hooks";
import { update } from "../../../features/formDataSlice";
import { Button, Container, Form, Col, Row, Toast, Stack } from "react-bootstrap";

interface EligibilityComponentProps {
  isEligible: boolean;
  setIsEligible: Function;
  shouldNotEligibleNotificationAppear: boolean;
  setShouldNotEligibleNotificationAppear: Function;
  shouldEligibleNotificationAppear: boolean;
  setShouldEligibleNotificationAppear: Function;
  checkEligibility: Function;
  isLoading: boolean;
  showQuestions: Function;
  apiStatus: any;
  isFormFillable: boolean;
  setIsFormFillable: Function;
  updateEligibiltyTimeout: Function;
  showActiveLivelyNumberError: boolean;
  setShowActiveLivelyNumberError: Function;
}

export const EligibilityComponent = ({
  isEligible,
  setIsEligible,
  shouldNotEligibleNotificationAppear,
  setShouldNotEligibleNotificationAppear,
  shouldEligibleNotificationAppear,
  setShouldEligibleNotificationAppear,
  checkEligibility,
  isLoading,
  showQuestions,
  apiStatus,
  isFormFillable,
  setIsFormFillable,
  updateEligibiltyTimeout,
  showActiveLivelyNumberError,
  setShowActiveLivelyNumberError
}: EligibilityComponentProps) => {

  const formState = useAppSelector((state) => state.formData.value);
  const dispatch = useAppDispatch();

  const carrierTextKey = useMemo(
    () =>
      formState.primaryAccountHolder
        ? "primaryPhoneFormDisclaimer"
        : "nonPrimaryPhoneFormDisclaimer",
    [formState.primaryAccountHolder]
  );
  const carrierTexts = useMemo(
    () =>
      phoneCarriers.find((p) => p.id === formState.primaryKeyFromCarrierList),
    [formState.primaryKeyFromCarrierList]
  );
  const isOtherProviderNeeded = useMemo(
    () => formState.provider.toLowerCase() === "zzz_other",
    [formState.provider]
  );
  const selectedPhoneCarriers = formState.landline
    ? phoneCarriers.filter((carrier) =>
        carrier["cell-landline"]
          .toLowerCase()
          .includes(t("transfer_phone.typeLandline").toLocaleLowerCase())
      )
    : phoneCarriers.filter((carrier) =>
        carrier["cell-landline"]
          .toLowerCase()
          .includes(t("transfer_phone.typeCellPhone").toLocaleLowerCase())
      );

  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement | null>(null);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | Event) => {
      if (
        anchorRef.current &&
        "contains" in anchorRef.current &&
        event.target &&
        !anchorRef.current.contains(event.target as Node) &&
        anchorEl &&
        "contains" in anchorEl &&
        event.target &&
        !anchorEl.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    if (open) {
      window.addEventListener("click", handleClickOutside);
    }

    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, [open, anchorEl]);

  const handleButtonClick = () => {
    setOpen(true);
    setAnchorEl(anchorRef.current);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const id = open ? "popper-id" : undefined;

  function updatePhoneState(id: number) {
    const carrier = phoneCarriers.find((opt) => opt.id === id);
    const provider = carrier?.value;
    const serviceNumberOwnerId = carrier?.serviceNumberOwnerId;

    dispatch(update({...formState, 
        primaryKeyFromCarrierList: id,
        provider: provider,
        serviceNumberOwnerId: serviceNumberOwnerId,
        primaryAccountHolder: "",
        inputProvider: "",}));
  }

  useEffect(() => {
    setIsFormFillable(false);
  }, [formState.primaryAccountHolder, formState.landline]);

  return (
    <>
      <Container fluid className="px-0">
        <Form onSubmit={(e) => e.preventDefault()}>
          <Row className=" mx-0 transfer-phone-header-main-divider">
          </Row>
          <Container fluid className="p-4 pb-5 eligibility-check-container">
            <Row>
              <h2 className="t-phone-form-container-title-2 mb-4 fw-bold">
                {t("transfer_phone.subtitle")}
              </h2>
            </Row>

            <Row>
              <Form.Group>
                <Form.Label className="fw-bold fs-5"> {t("transfer_phone.enterPhone")} </Form.Label>

                <Row>
                  <Col xs="auto" sm="auto" md="auto" lg="auto" className="mt-1">
                    <TextInput
                      name="eligibilityNumber"
                      type="text"
                      width="165px"
                      className="eligibility-check-phone-input"
                      height={'auto'}
                      normalize={maskPhoneInput}
                      onChange={(val, e) => {
                        e.preventDefault();
                        updateEligibiltyTimeout();
                        setShouldEligibleNotificationAppear(false);
                        setIsEligible(false);
                        setShouldNotEligibleNotificationAppear(false);
                        setShowActiveLivelyNumberError(false);
                        // eslint-disable-next-line
                        if (
                         val.replace(/[\(\)\s-]/g, "").length !==
                          US_PHONE_LEN
                        ) {
                          // Reset isEligible
                          isEligible && setIsEligible(false);
                        }
                        const maskedPhoneInput = maskPhoneInput(val);

                        dispatch(update({ ...formState, eligibilityNumber: maskedPhoneInput }));
                      }} />
                  </Col>

                  <Col xs="auto" sm="auto" md="auto" lg="auto" className="mt-1">
                    <Button className="transfer-phone-form-button check-eligibility-button"
                      onClick={checkEligibility as any}
                      disabled={
                        // eslint-disable-next-line
                        formState.eligibilityNumber?.replace(/[\(\)\s-]/g, "")
                          .length !== 10 ||
                        isEligible ||
                        isLoading
                      }> {t("transfer_phone.checkEligibility")} </Button>
                  </Col>
                </Row>
              </Form.Group>
            </Row>

            {shouldEligibleNotificationAppear && (
              <Toast show={shouldEligibleNotificationAppear} onClose={() => {
                showQuestions();
                setShouldEligibleNotificationAppear(false);
              }} className="mt-3 is-eligible-disclaimer">
                <Toast.Header className="border-bottom-0 pb-0">
                  <div className="me-auto"></div>
                </Toast.Header>
                <Toast.Body className="pt-0">
                  <Row className="mb-2">
                    <Col xs={1} sm={1} md={1} lg={1}  className="d-flex align-items-center justify-content-center ms-2">
                      <FontAwesomeIcon size="xl" icon={faCheck} />
                    </Col>
                    <Col className="ms-2">
                      <Stack>
                        <div className="fs-6 fw-bold">
                          {t("transfer_phone.isEligibleYes")}
                        </div>
                        <div className="fs-6">
                          {t("transfer_phone.isEligibleText")}
                        </div>
                      </Stack>
                    </Col>
                  </Row>
                </Toast.Body>
              </Toast>
            )}

            {shouldNotEligibleNotificationAppear && (
              <Container fluid className="is-not-eligible-container mt-3 ps-3">
                <Row>
                  <Col className="fw-bold py-3">
                    {t("transfer_phone.isNotEligibleMessage")}
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <p>{t("transfer_phone.isNotEligibleReason.header")}</p>
                    <ul className="is-not-eligible-reason">
                      <li>{t("transfer_phone.isNotEligibleReason.reason1")}</li>
                      <li>{t("transfer_phone.isNotEligibleReason.reason2")}</li>
                      <li>{t("transfer_phone.isNotEligibleReason.reason3")}</li>
                      <li>{t("transfer_phone.isNotEligibleReason.reason4")}</li>
                    </ul>
                  </Col>
                </Row>

                <Row className="pb-4">
                  <Col>
                    {t("transfer_phone.isNotEligibleContactCarrier")}
                  </Col>
                </Row>
              </Container>
            )
            }

            {showActiveLivelyNumberError && (
                <Container fluid className="is-not-eligible-container mt-3 ps-3">
                  <Row>
                  <Col className="fw-bold py-3">
                    <FontAwesomeIcon size="lg" icon={faExclamationCircle} color="red" />
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    {t("transfer_phone.isActiveLivelyNumber.numberExists")}
                  </Col>
                  </Row>

                    <Row>
                    <Col className="ps-5">
                      {formState.deviceType === 'sim' ? (
                      <p>{t("transfer_phone.isActiveLivelyNumber.contactUsSim")}</p>
                      ) : (
                      <p>{t("transfer_phone.isActiveLivelyNumber.contactUs")}</p>
                      )}
                    </Col>
                    </Row>
                </Container>
            )
            }

            {!apiStatus && (
              <Toast show={!apiStatus} className="mt-3 pt-1 is-not-eligible-disclaimer">
                <Toast.Header closeButton={false} className="border-bottom-0 pb-0">
                  <div className="me-auto"></div>
                </Toast.Header>
                <Toast.Body className="pt-0">
                  <Row className="mb-2">
                    <Col xs={1} sm={1} md={1} lg={1} className="d-flex align-items-center justify-content-center ms-2">
                      <FontAwesomeIcon size="xl" icon={faTriangleExclamation} />
                    </Col>
                    <Col className="ms-2">
                      <div className="fs-6 fw-bold">
                        {t("transfer_phone.isInternalError")}
                      </div>
                    </Col>
                  </Row>
                </Toast.Body>
              </Toast>
            )}
          </Container>

          {isEligible && (
            <>
              <Row className=" mx-0 mt-5 transfer-phone-header-main-divider">
              </Row>
              <Container fluid className="p-4 pb-5 eligibility-check-container">
                <Row className="mb-4">
                  <h2 className="t-phone-form-container-title-2 fw-bold">
                    {t("transfer_phone.typeOfPhone")}
                  </h2>
                </Row>

                <Row className="mb-2">
                  <Form.Group>
                    <Form.Label className="fw-bold fs-6"> {t("transfer_phone.typeOfPhone2")} </Form.Label>

                    <Row className="mt-1">
                      <Col xs="auto" sm="auto" md="auto" lg="auto">

                        <Form.Check
                          type="radio"
                          className="d-flex align-items-center justify-content-center gap-2"
                          checked={formState.landline !== "" && !formState.landline}
                          name="cell"
                          onClick={() => {
                            dispatch(update({
                              ...formState,
                              provider: "",
                              landline: false
                            }));
                          }}
                          label={t("transfer_phone.typeCellPhone")}
                        />
                      </Col>

                      <Col xs="auto" sm="auto" md="auto" lg="auto">
                        <Form.Check
                          type="radio"
                          className="d-flex align-items-center justify-content-center gap-2"
                          checked={formState.landline}
                          name="landline"
                          onClick={() => {
                            dispatch(update({
                              ...formState,
                              provider: "",
                              landline: true
                            }));
                          }}
                          label={t("transfer_phone.typeLandline")}
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                </Row>

                {formState.landline !== "" && (
                  <>
                    <Row className="mb-2">
                      <Col className="ps-2" xs="auto" sm="auto" md="auto" lg="auto" xl="auto" xxl="auto">
                        <Dropdown
                          name="carrier"
                          options={selectedPhoneCarriers}
                          boldLabel={true}
                          label={t("transfer_phone.selectCarrier")!}
                          headerPlaceholder={t(
                            "transfer_phone.selectCarrierPlaceholder"
                          )}
                          onChange={(primaryKeyFromCarrierList: number) => {
                            updatePhoneState(primaryKeyFromCarrierList);
                          }}
                          width="391px"
                          height="38px"
                        />
                      </Col>
                    </Row>

                    {!isOtherProviderNeeded && (
                      <Row className="mb-3">

                      </Row>
                    )}

                    {isOtherProviderNeeded && (
                      <Row className="mb-4">
                        <Col className="ps-0">
                          <TextInput
                            name="otherProvider"
                            labelText={t("transfer_phone.phoneForm.inputProvider")!}
                            placeholder={
                              t("transfer_phone.phoneForm.inputProviderPlaceholder")!
                            }
                            width="420px"
                            value={formState.inputProvider}
                            onChange={(val) => {
                              dispatch(update({
                                ...formState,
                                inputProvider: val
                              }));
                            }}
                          />
                        </Col>
                      </Row>)}
                  </>
                )}

                {formState.provider !== "" &&
                  ((isOtherProviderNeeded && formState.inputProvider !== "") ||
                    !isOtherProviderNeeded) && (
                  <>
                    <Row className="mb-5">
                      <Form.Group>
                        <Row>
                          <Col className="pe-0" xs="auto" sm="auto" md="auto" lg="auto">
                            <Form.Label className="fw-bold fs-6"> {t("transfer_phone.primaryAccountHolderTitle")} </Form.Label>
                          </Col>

                          <Col className="ps-0" xs="auto" sm="auto" md="auto" lg="auto">
                            <button
                              type="button"
                              ref={anchorRef}
                              className="popper-button popper-info-button"
                              style={{ marginBottom: "5px", marginLeft: "5px" }}
                              onClick={handleButtonClick}
                            >
                              <InfoLogo />
                            </button>
                          </Col>
                        </Row>

                        <Popper
                          id={id}
                          open={open}
                          anchorEl={anchorEl}
                          placement="top-end"
                          disablePortal
                        >
                          <div className="popper-content">
                            <div className="popper-header">
                              <button className="close-button" onClick={handleClose}>
                                <FontAwesomeIcon icon={faTimes} />
                              </button>
                            </div>
                            <div className="popper-text">
                              {t("transfer_phone.popoverPrimaryAccountHolder")}
                            </div>
                          </div>
                        </Popper>

                        <Row className="mt-1">
                          <Col xs="auto" sm="auto" md="auto" lg="auto">

                            <Form.Check
                              type="radio"
                              className="d-flex align-items-center justify-content-center gap-2"
                              checked={formState.primaryAccountHolder}
                              name="radio"
                              onClick={() => {
                                dispatch(update({
                                  ...formState,
                                  primaryAccountHolder: true,
                                }));
                              }}
                              label={t("transfer_phone.primaryAccountHolderYes")}
                            />
                          </Col>

                          <Col xs="auto" sm="auto" md="auto" lg="auto">
                            <Form.Check
                              type="radio"
                              className="d-flex align-items-center justify-content-center gap-2"
                              checked={
                                formState.primaryAccountHolder !== "" &&
                                !formState.primaryAccountHolder
                              }
                              name="radio"
                              onClick={() => {
                                dispatch(update({
                                  ...formState,
                                  primaryAccountHolder: false,
                                }));
                              }}
                              label={t("transfer_phone.primaryAccountHolderNo")}
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </Row>
                  </>
                  )}

            {formState.primaryAccountHolder !== "" && (
                  <>
                    <Container fluid className="t-phone-form-disclaimer-container p-4 mb-4">
                      <Row>
                        <Col className="fw-bold fs-4">
                          {carrierTexts?.[carrierTextKey].title}
                        </Col>
                      </Row>

                      {carrierTexts?.[carrierTextKey].firstItemTitle && (
                        <Row className="fw-bold">
                          <Col>
                            {carrierTexts?.[carrierTextKey].firstItemTitle}
                          </Col>
                        </Row>
                      )}

                      <Row>
                        <Row>
                          <Col>
                            <div
                              dangerouslySetInnerHTML={{
                                __html:
                                  carrierTexts?.[carrierTextKey].firstItemText1 ?? "",
                              }}
                            ></div>
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            {carrierTexts?.[carrierTextKey].firstItemText2}
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            {carrierTexts?.[carrierTextKey].firstItemText3}
                          </Col>
                        </Row>
                      </Row>


                      {carrierTexts?.[carrierTextKey].secondItemTitle && (
                        <Row className="fw-bold">
                          <Col>
                            {carrierTexts?.[carrierTextKey].secondItemTitle}
                          </Col>
                        </Row>
                      )}

                      <Row>
                        <Col>
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                carrierTexts?.[carrierTextKey].secondItemText1 ??
                                "",
                            }}
                          ></div>
                        </Col>
                      </Row>

                      <Row>
                        <Col>
                          {carrierTexts?.[carrierTextKey].secondItemText2}
                        </Col>
                      </Row>

                      <Row>
                        <Col>
                          {carrierTexts?.[carrierTextKey].secondItemText3}
                        </Col>
                      </Row>
                    </Container>
                  </>
            )}

                {!isFormFillable && formState.primaryAccountHolder !== "" && (
                  <Row>
                    <Col md="auto">
                      <Button
                        className={`transfer-phone-form-button ${!formState.provider && "button-disabled"
                          }`}
                        disabled={!formState.provider}
                        onClick={() => {

                          TagManager.dataLayer({
                            dataLayer: {
                              event: "porting_event",
                              event_name: "phone_info_confirmed",
                              form_name: "Porting",
                              form_step: "check eligibility",
                              form_step_action: "continue"
                            },
                          });
                          setIsFormFillable(true);
                        }}
                      >
                        {t("transfer_phone.haveInfo")}
                      </Button>
                    </Col>
                  </Row>
                )}
              </Container>
            </>
          )}
        </Form>
      </Container>
    </>
  );
};
